<template>
  <v-card class="pb-4" outlined>
    <v-card-title class="py-1">
      {{ $t('ELE0028') }}
    </v-card-title>
    <v-card-text class="py-1">
      <v-row>
        <v-col>
          <ValidationObserver v-slot="{ invalid }">
            <v-row>
              <v-col>
                <TextFieldRef v-if="isSearched" :value="searchCondition.saNo" :label="$t('ELE0184')" />
                <TextFieldInput v-else v-model="searchCondition.saNo" :label="$t('ELE0184')" required />
              </v-col>
              <v-col cols="8">
                <span v-if="!isModal" d-flex flex-row space-between>
                  <BtnSearch class="ml-4" @click="onClickSearch" :disabled="invalid || isSearched" />
                  <BtnReset class="mx-4" @click="onClickResetForm" :disabled="!isSearched" />
                </span>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-col>
      </v-row>
      <v-container class="mx-0 mt-4" v-if="isSearched">
        <v-row dense>
          <v-col class="px-1">
            <v-card outlined>
              <v-simple-table class="header-gray" fixed-header dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left v-data-table__divider">{{ $t('ELE0042') }}</th>
                      <th class="text-left">{{ $t('ELE0190') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in saInfo.info1" :key="item.name">
                      <td class="v-data-table__divider">{{ item.name }}</td>
                      <td :class="item.class">{{ item.value }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col class="px-1">
            <v-card outlined>
              <v-simple-table class="header-gray" fixed-header dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left v-data-table__divider">{{ $t('ELE0042') }}</th>
                      <th class="text-left">{{ $t('ELE0190') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in saInfo.info2" :key="item.name">
                      <td class="v-data-table__divider">{{ item.name }}</td>
                      <td :class="item.class">{{ item.value }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="pt-4 pb-2">
          <v-col cols="4">
            <v-card class="pb-2" max-width="700px" outlined>
              <v-card-title class="py-1">
                {{ $t('ELE0253') }}
              </v-card-title>
              <v-card class="mx-2" outlined>
                <v-data-table
                  :headers="lotListHeaders"
                  :items="this.form.saLots"
                  dense
                  disable-pagination
                  hide-default-footer
                  mobile-breakpoint="0"
                >
                </v-data-table>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="8">
            <TextAreaRef :label="$t('ELE0054')" :value="this.form.reasonDtl" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card max-width="800px" outlined>
              <v-tabs fixed-tabs v-model="inspClassTab">
                <v-tab class="ml-0" :href="`#${enumInspClassCd.DIM}`">
                  {{ $t('ELE0229') }}
                </v-tab>
                <v-tab :href="`#${enumInspClassCd.APP}`">
                  {{ $t('ELE0211') }}
                </v-tab>
                <v-tab-item :value="`${enumInspClassCd.DIM}`">
                  <v-card class="pb-2">
                    <v-card-title class="py-0 pb-1">
                      <v-spacer />
                    </v-card-title>
                    <v-card class="mx-2" outlined>
                      <v-data-table
                        :headers="headersDim"
                        :items="this.form.saDims"
                        dense
                        disable-pagination
                        hide-default-footer
                        mobile-breakpoint="0"
                      >
                        <template #header>
                          <thead>
                            <tr>
                              <th colspan="2" class="v-data-table__divider"></th>
                              <th colspan="3" class="v-data-table__divider">{{ $t('ELE0179') }}</th>
                              <th colspan="3">{{ $t('ELE0180') }}</th>
                            </tr>
                          </thead>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-card>
                </v-tab-item>
                <v-tab-item :value="`${enumInspClassCd.APP}`">
                  <v-card class="pb-2" max-width="800px" flat>
                    <v-card-title class="pt-0 pb-1"> </v-card-title>
                    <v-card class="mx-2" outlined>
                      <v-data-table
                        :headers="headersApp"
                        :items="this.form.saApps"
                        dense
                        disable-pagination
                        hide-default-footer
                        mobile-breakpoint="0"
                      >
                      </v-data-table>
                    </v-card>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import { API } from '@/plugins/api'
import { InspClassCd } from '@/enum'
import BigNumber from 'bignumber.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import TextAreaRef from '@/components/atoms/base/text-field/TextAreaRef'
import Btn from '@/components/atoms/base/button/Btn'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnReset from '@/components/atoms/button/BtnReset'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'

export default {
  name: 'SearchSaDetailForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    ValidationObserver,
    TextFieldInput,
    TextFieldRef,
    TextAreaRef,
    Btn,
    BtnSearch,
    BtnReset,
    SelectSingleInput,
  },

  props: {
    propsSaNo: {
      type: String,
      default: '',
      required: false,
    },
    isModal: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    enumInspClassCd: () => InspClassCd,
    isSearched: {
      get() {
        let result = false
        if (this.form !== null) {
          result = true
        }
        return result
      },
    },
  },

  data() {
    return {
      form: null,
      inspClassTab: '',
      saInfo: { info1: [], info2: [] },
      searchCondition: {
        saNo: '',
      },
      lotListHeaders: [{ text: this.$t('ELE0049'), value: 'lot' }],
      headersDim: [
        {
          text: this.$t('ELE0091'),
          value: 'inspCharacCd',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
        },
        {
          text: this.$t('ELE0092'),
          value: 'inspCharacPoint',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
        },
        {
          text: this.$t('ELE0095'),
          value: 'standard',
          divider: true,
          sortable: false,
          align: 'end',
          cellClass: 'py-1',
        },
        { text: this.$t('ELE0096'), value: 'upper', divider: true, sortable: false, align: 'end', cellClass: 'py-1' },
        { text: this.$t('ELE0097'), value: 'lower', divider: true, sortable: false, align: 'end', cellClass: 'py-1' },
        {
          text: this.$t('ELE0095'),
          value: 'saStandard',
          divider: true,
          sortable: false,
          align: 'end',
          cellClass: 'py-1',
        },
        { text: this.$t('ELE0096'), value: 'saUpper', divider: true, sortable: false, align: 'end', cellClass: 'py-1' },
        { text: this.$t('ELE0097'), value: 'saLower', sortable: false, align: 'end', cellClass: 'py-1' },
      ],
      headersApp: [{ text: this.$t('ELE0033'), value: 'fileTitle', sortable: false, cellClass: 'py-1' }],
    }
  },

  methods: {
    onClickResetForm() {
      this.form = null
      this.searchCondition.saNo = ''
    },
    async onClickSearch() {
      try {
        this.startLoading()
        const params = {
          saNo: this.searchCondition.saNo,
          userCompanyCd: this.$store.getters.companyCd,
        }

        const elements = await API.get('/sa/info', params)
        await this.setSaInfo(elements)
        if (elements.saDims.length == 0 && elements.saApps.length >= 0) {
          this.inspClassTab = InspClassCd.APP
        } else {
          this.inspClassTab = InspClassCd.DIM
        }
        this.form = elements
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0291') })))
      } finally {
        this.stopLoading()
      }
    },
    setSaInfo(info) {
      let info1 = []
      info1.push({ name: this.$t('ELE0387'), value: this.toLocalTime(info.requestDatetme), class: '' })
      info1.push({ name: this.$t('ELE0217'), value: this.$t(`SaApprovalStatusCd.${info.statusCd}`), class: '' })
      info1.push({ name: this.$t('ELE0381'), value: this.$t(`SaRuleCd.${info.saRule}`), class: '' })
      info1.push({ name: this.$t('ELE0385'), value: info.startDate, class: '' })
      info1.push({ name: this.$t('ELE0386'), value: info.endDate, class: '' })
      info1.push({ name: '', value: '', class: '' })

      let info2 = []
      info2.push({ name: this.$t('ELE0031'), value: info.partCd, class: '' })
      info2.push({ name: this.$t('ELE0032'), value: info.partName, class: '' })
      info2.push({ name: this.$t('ELE0003'), value: info.requestCompanyCd, class: '' })
      info2.push({ name: this.$t('ELE0004'), value: info.requestCompanyName, class: '' })
      info2.push({ name: this.$t('ELE0382'), value: info.saQty, class: 'text-right' })

      info2.push({
        name: this.$t('ELE0384'),
        value: info.totalInspQty,
        class: this.getTotalInspQtyClass(info.saQty, info.totalInspQty),
      })

      this.saInfo.info1 = info1
      this.saInfo.info2 = info2
    },
    getTotalInspQtyClass(saQty, totalInspQty) {
      let result = 'text-right'
      if (BigNumber(saQty).lte(BigNumber(totalInspQty))) {
        result = `${result} red-color`
      }
      return result
    },
  },

  mounted() {
    if (this.propsSaNo != '') {
      this.searchCondition.saNo = this.propsSaNo
      this.onClickSearch()
    }
  },
}
</script>
<style scoped>
.red-color {
  background-color: #f8ced2 !important;
}
</style>
